import { TaskError } from '../../errors/TaskError';
import { AbstractTask } from './AbstractTask';
import { CreateParts } from './CreateParts';
import { LockTransfer } from './LockTransfer';
import { UploaderError } from '../../errors/UploaderError';
export class UpdateFile extends AbstractTask {
    constructor(context, file) {
        super(context);
        this.sdkFatalErrors = [
            this.context.transferSdk.errors.UpdateTransferFileError.InvalidParameterError,
            this.context.transferSdk.errors.UpdateTransferFileError.NotFoundError,
            this.context.transferSdk.errors.UpdateTransferFileError.TransferAlreadyLockedError,
            this.context.transferSdk.errors.UpdateTransferFileError.UnauthorizedError,
            this.context.transferSdk.errors.UpdateTransferFileError.UnknownError,
            this.context.transferSdk.errors.GetTeamTransferFileError.NotFoundError,
            this.context.transferSdk.errors.GetTeamTransferFileError.UnauthorizedError,
            this.context.transferSdk.errors.GetTeamTransferFileError.UnknownError,
            this.context.transferSdk.errors.GetTeamTransferFileError.InvalidParameterError,
            this.context.transferSdk.errors.GetTransferFileError.NotFoundError,
            this.context.transferSdk.errors.GetTransferFileError.UnauthorizedError,
            this.context.transferSdk.errors.GetTransferFileError.UnknownError,
            this.context.transferSdk.errors.GetTransferFileError.InvalidParameterError,
        ];
        this.transfer = context.transfer;
        this.file = file;
        this.updateTransferFileParameters = {
            transferId: this.transfer.id,
            fileId: this.file.id,
        };
        if (this.file.hasInlinePartsToValidate()) {
            const parts = this.file.getInlinePartsToValidate();
            this.updateTransferFileParameters.parts = parts.map(part => ({ id: part.id, etag: part.etag, crc32: part.crc32 }));
        }
    }
    preProcess(context) {
        return this;
    }
    updateFile() {
        return new Promise(async (resolve, reject) => {
            try {
                const file = await this.context.transferSdk.updateTransferFile(this.updateTransferFileParameters);
                resolve(file);
            }
            catch (error) {
                if (error instanceof this.context.transferSdk.errors.UpdateTransferFileError.FileAlreadyLockedError) {
                    try {
                        if (this.transfer.teamId) {
                            const file = await this.context.transferSdk.getTeamTransferFile({ transferId: this.transfer.id, teamId: this.transfer.teamId, fileId: this.file.id });
                            resolve(file);
                        }
                        else {
                            const file = await this.context.transferSdk.getTransferFile({ transferId: this.transfer.id, fileId: this.file.id });
                            resolve(file);
                        }
                    }
                    catch (error) {
                        reject(error);
                    }
                }
                else {
                    reject(error);
                }
            }
        });
    }
    process() {
        return new Promise(async (resolve) => {
            try {
                this.response = await this.updateFile();
            }
            catch (error) {
                if (error instanceof this.context.transferSdk.errors.UpdateTransferFileError.InvalidParameterError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFileError.NotFoundError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFileError.TransferAlreadyLockedError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFileError.UnauthorizedError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFileError.UnknownError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFileError.InternalServerError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFileError.BadGatewayError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFileError.GatewayTimeoutError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFileError.NetworkError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFileError.TimeoutError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFileError.ConnectionAbortedError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferFileError.NotFoundError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferFileError.UnauthorizedError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferFileError.UnknownError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferFileError.InvalidParameterError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferFileError.InternalServerError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferFileError.BadGatewayError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferFileError.GatewayTimeoutError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferFileError.NetworkError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferFileError.TimeoutError ||
                    error instanceof this.context.transferSdk.errors.GetTeamTransferFileError.ConnectionAbortedError ||
                    error instanceof this.context.transferSdk.errors.GetTransferFileError.NotFoundError ||
                    error instanceof this.context.transferSdk.errors.GetTransferFileError.UnauthorizedError ||
                    error instanceof this.context.transferSdk.errors.GetTransferFileError.UnknownError ||
                    error instanceof this.context.transferSdk.errors.GetTransferFileError.InvalidParameterError ||
                    error instanceof this.context.transferSdk.errors.GetTransferFileError.InternalServerError ||
                    error instanceof this.context.transferSdk.errors.GetTransferFileError.BadGatewayError ||
                    error instanceof this.context.transferSdk.errors.GetTransferFileError.GatewayTimeoutError ||
                    error instanceof this.context.transferSdk.errors.GetTransferFileError.NetworkError ||
                    error instanceof this.context.transferSdk.errors.GetTransferFileError.TimeoutError ||
                    error instanceof this.context.transferSdk.errors.GetTransferFileError.ConnectionAbortedError) {
                    this.error = new TaskError(this, error);
                }
                else {
                    this.error = new TaskError(this, error);
                }
            }
            resolve(this);
        });
    }
    processError() {
        if (this.error) {
            if (this.error.isInstanceOfOneOfTheseErrors(this.sdkFatalErrors)) {
                this.error.unrecoverableError(new UploaderError(this.error.getError()));
            }
            else if (this.error.getError() instanceof this.context.transferSdk.errors.UpdateTransferFileError.NetworkError ||
                this.error.getError() instanceof this.context.transferSdk.errors.UpdateTransferFileError.TimeoutError ||
                this.error.getError() instanceof this.context.transferSdk.errors.UpdateTransferFileError.ConnectionAbortedError ||
                this.error.getError() instanceof this.context.transferSdk.errors.GetTeamTransferFileError.NetworkError ||
                this.error.getError() instanceof this.context.transferSdk.errors.GetTeamTransferFileError.TimeoutError ||
                this.error.getError() instanceof this.context.transferSdk.errors.GetTeamTransferFileError.ConnectionAbortedError ||
                this.error.getError() instanceof this.context.transferSdk.errors.GetTransferFileError.NetworkError ||
                this.error.getError() instanceof this.context.transferSdk.errors.GetTransferFileError.TimeoutError ||
                this.error.getError() instanceof this.context.transferSdk.errors.GetTransferFileError.ConnectionAbortedError) {
                this.error.setRecoveryTask(this.error.getTask());
            }
            else if (this.error.getError() instanceof this.context.transferSdk.errors.UpdateTransferFileError.InternalServerError) {
                this.retryFileParts();
            }
            else if (this.executionNumber < this.maxExecutionNumber) {
                this.error.setRecoveryTask(this.error.getTask());
            }
            else {
                this.error.unrecoverableError(new UploaderError(this.error.getError()));
            }
            return this.error;
        }
        throw new Error('Method task.processError() should be called only if task.isOnError() === true');
    }
    postProcess(context) {
        this.transfer.populateCompletedFile(this.file, this.response);
        if (this.transfer.hasAllFilesUploaded()) {
            context.lockTransferQueue.add(new LockTransfer(this.context));
        }
        return null;
    }
    retryFileParts() {
        this.file.resetParts();
        this.context.createPartsQueue.add(new CreateParts(this.context, this.file, this.file.partsToCreate));
    }
}
